module.exports = __webpack_public_path__ + "static/ai-poster-2-ec1605508288b01c0a06e6cf4574ef28.png";